"use client";

import Link from "next/link";
import { useAppFeatureFlag } from "@/components/feature-flags/feature-flags-provider";
import {
  SITE_CONTROL_NAME,
  SITE_CONTROL_PRICE_DISPLAY,
  SITE_CONTROL_PRICE_PERIOD,
} from "@/lib/site-control-copy";

/**
 * Homepage pricing-section note for Site Control — the per-site enterprise
 * tier, sat alongside the Business note.
 *
 * Self-gating on the `site_control` flag (read from the marketing layout's
 * AppFeatureFlagsProvider). Kept as a client child so the homepage keeps
 * streaming its hero/LCP without blocking the whole document on a DB flag read
 * (the page deliberately isolates its other flag read in a Suspense'd child) —
 * and so the tier note appears/disappears in lockstep with the rest of the
 * Site Control surface.
 */
export function SiteControlHomeNote() {
  const enabled = useAppFeatureFlag("site_control");
  if (!enabled) return null;

  return (
    <div className="mt-3 rounded-xl border border-navy/15 bg-background px-4 py-3 text-left text-sm leading-relaxed text-muted">
      <p>
        <strong className="text-navy">
          Running live sites with subcontractors?
        </strong>{" "}
        {SITE_CONTROL_NAME} is our per-site enterprise tier for principal
        contractors — entrance QR sign-in, CSCS checks, induction gating and
        live people-on-site, from{" "}
        {`${SITE_CONTROL_PRICE_DISPLAY}${SITE_CONTROL_PRICE_PERIOD}`} plus
        setup.
      </p>
      <Link
        href="/site-control"
        className="mt-2 inline-flex font-semibold text-accent hover:text-accent-dark"
      >
        Explore Site Control →
      </Link>
    </div>
  );
}
